import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { checkMailChimpStatus, createMailChimpMember, updateMailChimpMember } from '../../util/api';
import _ from 'lodash';
export const ASSET_NAME = 'landing-page';

export const SEARCH_LISTINGS_SUCCESS = 'app/LandingPage/SEARCH_LISTINGS_SUCCESS';
export const SEARCH_LISTINGS_ERROR = 'app/LandingPage/SEARCH_LISTINGS_ERROR';

export const CHECK_MAILCHIMP_SUCCESS = 'app/LandingPage/CHECK_MAILCHIMP_SUCCESS';
export const CHECK_MAILCHIMP_ERROR = 'app/LandingPage/CHECK_MAILCHIMP_ERROR';

export const NEWSLETTER_UPDATE_REQUEST = 'app/LandingPage/NEWSLETTER_UPDATE_REQUEST';
export const NEWSLETTER_UPDATE_SUCCESS = 'app/LandingPage/NEWSLETTER_UPDATE_SUCCESS';
export const NEWSLETTER_UPDATE_ERROR = 'app/LandingPage/NEWSLETTER_UPDATE_ERROR';

export const NOSUBSCRIBENEWLETTER_REQUEST = 'app/LandingPage/NOSUBSCRIBENEWLETTER_REQUEST';
export const NOSUBSCRIBENEWLETTER_SUCCESS = 'app/LandingPage/NOSUBSCRIBENEWLETTER_SUCCESS';
export const NOSUBSCRIBENEWLETTER_ERROR = 'app/LandingPage/NOSUBSCRIBENEWLETTER_';

const initialState = {
  pagination: null,
  searchInProgress: false,
  searchListingsError: null,
  currentPageResultIds: [],
  fetchCheckMailChimpStatusError: null,
  isMailChimpMember: true,
  mailChimpStatus: null,
  mailChimpSubsribed: true,
  isNewLetterUpdate: false,
};

const resultIds = data => data.data.map(l => l.id);
const landingPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SEARCH_LISTINGS_SUCCESS:
      return {
        ...state,
        currentPageResultIds: resultIds(payload.data),
        pagination: payload.data.meta,
        searchInProgress: false,
      };
    case SEARCH_LISTINGS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, searchInProgress: false, searchListingsError: payload };

    case CHECK_MAILCHIMP_SUCCESS:
      return {
        ...state,
        isMailChimpMember: payload.isMailChimpMember,
        mailChimpStatus: payload.mailChimpStatus,
        mailChimpSubsribed: payload.mailChimpSubsribed,
      };

    case CHECK_MAILCHIMP_ERROR:
      return { ...state, fetchCheckMailChimpStatusError: payload };

    case NEWSLETTER_UPDATE_SUCCESS:
      return {
        ...state,
        isNewLetterUpdate: true,
      };

    case NOSUBSCRIBENEWLETTER_SUCCESS:
      return {
        ...state,
        isNewLetterUpdate: true,
      };

    case NOSUBSCRIBENEWLETTER_ERROR:
      return { ...state, fetchCheckMailChimpStatusError: payload };
    default:
      return state;
  }
};

export default landingPageReducer;

export const searchListingsSuccess = response => ({
  type: SEARCH_LISTINGS_SUCCESS,
  payload: { data: response.data },
});

export const searchListingsError = e => ({
  type: SEARCH_LISTINGS_ERROR,
  error: true,
  payload: e,
});

export const checkMailChimpStatusSucess = transaction => ({
  type: CHECK_MAILCHIMP_SUCCESS,
  payload: {
    isMailChimpMember: transaction.isExist,
    mailChimpStatus: transaction.status,
    mailChimpSubsribed: transaction.subsribed,
  },
});

export const checkMailChimpStatusError = error => ({
  type: CHECK_MAILCHIMP_ERROR,
  error: true,
  payload: error,
});

export const newsletterUpdateRequest = () => ({ type: NEWSLETTER_UPDATE_REQUEST });
export const newsletterUpdateSuccess = () => ({ type: NEWSLETTER_UPDATE_SUCCESS });
export const newsletterUpdateRequestError = error => ({
  type: NEWSLETTER_UPDATE_ERROR,
  payload: error,
  error: true,
});

export const nosubsribenewletterSucess = () => ({ type: NOSUBSCRIBENEWLETTER_SUCCESS });
export const nosubsribenewletterError = error => ({
  type: NOSUBSCRIBENEWLETTER_ERROR,
  payload: error,
  error: true,
});

export const loadData = (params, search, config) => dispatch => {
  return dispatch(searchFeaturedListings(config));
};

export const searchFeaturedListings = config => (dispatch, getState, sdk) => {
  const query = {
    page: 1,
    include: ['author', 'images'],
    'fields.listing': [
      'title',
      'geolocation',
      'price',
      'publicData.listingType',
      'publicData.transactionProcessAlias',
      'publicData.period',
      'publicData.unitType',
      'publicData.pickupEnabled',
      'publicData.shippingEnabled',
    ],
    'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
    'fields.image': [
      'variants.scaled-small',
      'variants.scaled-medium',
      'variants.listing-card',
      'variants.listing-card-2x',
    ],
    'imageVariant.listing-card': 'w:400;h:300;fit:crop',
    'imageVariant.listing-card-2x': 'w:800;h:600;fit:crop',
    'limit.images': 1,
    minStock: 1,
    stockMode: 'match-undefined',
    perPage: 10,
  };
  return sdk.listings
    .query(query)
    .then(async response => {
      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };
      const user = await sdk.currentUser.show();
      const userEmail = user?.data?.data?.attributes?.email || '';
      const { newsletter } = user?.data?.data?.attributes?.profile?.protectedData || {};
      const params = {
        email: userEmail,
      };

      await checkMailChimpStatus(params)
        .then(async response => {
          // don't wanna subsribe
          if (newsletter === false) {
            const resp = { subsribed: true, status: '', isExist: true };
            dispatch(checkMailChimpStatusSucess(resp));
          } else {
            dispatch(checkMailChimpStatusSucess(response));
          }
        })
        .catch(e => {
          dispatch(fetchCheckMailChimpStatusError(storableError(e)));
        });

      dispatch(addMarketplaceEntities(response, sanitizeConfig));
      dispatch(searchListingsSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(searchListingsError(storableError(e)));
      throw e;
    });
};

export const createNewsletterSubsribeMember = (
  category,
  serviceType,
  region,
  jobType,
  essentialType
) => async (dispatch, getState, sdk) => {
  dispatch(newsletterUpdateRequest());

  const pb = {
    category,
    serviceType,
    region,
    jobType,
    essentialType,
  };

  try {
    const response = await sdk.currentUser.updateProfile(
      {
        publicData: {
          ...pb,
        },
        protectedData: {
          newsletter: true,
        },
      },
      { expand: true }
    );

    const { attributes, id } = response.data?.data || {};
    dispatch(newsletterUpdateSuccess());

    const newSelectedNewLetter = _.concat(..._.filter([category,serviceType, region,jobType, essentialType,],_.identity));
    const mailchimpUser = {
      email: attributes.email,
      fname: attributes.profile.firstName,
      lname: attributes.profile.lastName,
      sharetribid: id.uuid,
      displayname: attributes.profile.displayName,
      newSelectedNewLetter,
    };

    await createMailChimpMember(mailchimpUser);
    return response;
  } catch (e) {
    dispatch(newsletterUpdateRequestError(storableError(e)));
    throw e;
  }
};

export const updateNewsletterSubsribeMember = (
  category,
  serviceType,
  region,
  jobType,
  essentialType,
  previousSelectedNewLetter
) => async (dispatch, getState, sdk) => {
  dispatch(newsletterUpdateRequest());

  const pb = {
    category,
    serviceType,
    region,
    jobType,
    essentialType,
  };

  try {
    const response = await sdk.currentUser.updateProfile(
      {
        publicData: {
          ...pb,
        },
        protectedData: {
          newsletter: true,
        },
      },
      { expand: true }
    );

    const { attributes, id } = response.data?.data || {};
    dispatch(newsletterUpdateSuccess());

    const newSelectedNewLetter = _.concat(..._.filter([category,serviceType, region,jobType, essentialType,],_.identity));
    const mailchimpUser = {
      email: attributes.email,
      fname: attributes.profile.firstName,
      lname: attributes.profile.lastName,
      sharetribid: id.uuid,
      displayname: attributes.profile.displayName,
      newSelectedNewLetter,
      previousSelectedNewLetter
    };

    await updateMailChimpMember(mailchimpUser);
    return response;
  } catch (e) {
    dispatch(newsletterUpdateRequestError(storableError(e)));
    throw e;
  }
};

export const submitNoSubsribe = () => async (dispatch, getState, sdk) => {
  try {
    const response = await sdk.currentUser.updateProfile(
      {
        protectedData: {
          newsletter: false,
        },
      },
      {
        expand: true,
      }
    );
    if (response.status === 200) dispatch(nosubsribenewletterSucess());
    return response;
  } catch (e) {
    dispatch(nosubsribenewletterError(storableError(e)));
    throw e;
  }
};
